import React, { useCallback, useState } from "react";
import cx from "classnames";
import { TopologyEditableTitle } from "objs/_ConfiguratorObjs/Wizard/SubComponents/TopologyEditableTitle";
import { topologyConfig } from "components/Topology/configs/topologyConfig";
import { topologyColors } from "components/Topology/configs/topologyColors";
import { Button } from "components";
import { UncontrolledTooltip } from "reactstrap";
import { MAX_CUSTOM_PRODUCT_INPUT_LENGTH } from "variables";
import { useWizardActions } from "stores/wizardStore";
import s from "../../topology.module.scss";

const { nodeWidth, nodeHeight, rightChildrenGapX } = topologyConfig;
const { gray400, gray500, blue500 } = topologyColors;
const wifiIcon =
  "data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%20fill%3D%22%235CCDFF%22%2F%3E%3Cpath%20d%3D%22m8.515%2013.54-.682-.689A6.218%206.218%200%200%201%2012.281%2011a6.232%206.232%200%200%201%204.45%201.859l-.682.682a5.324%205.324%200%200%200-3.767-1.567c-.712%200-1.392.136-2.041.409a5.37%205.37%200%200%200-1.726%201.158zm-2.833-2.833L5%2010.025a10.158%2010.158%200%200%201%203.34-2.244A10.2%2010.2%200%200%201%2012.285%207c1.373%200%202.687.26%203.941.781a10.154%2010.154%200%200%201%203.338%202.244l-.682.682a9.246%209.246%200%200%200-3.025-2.024%209.255%209.255%200%200%200-3.575-.709%209.222%209.222%200%200%200-3.575.709%209.274%209.274%200%200%200-3.025%202.024zm6.6%206.6-1.632-1.636c.216-.216.465-.382.746-.498.281-.115.576-.173.885-.173.308%200%20.603.058.886.173.282.116.531.282.747.498l-1.632%201.636z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E";

export const ZoneTitle = React.memo(
  ({ title, zoneId, isWirelessZone = false }) => {
    const [editMode, setEditMode] = useState(false);
    const { updateZoneTitle } = useWizardActions();

    const handleEditMode = useCallback((val) => {
      setEditMode(val);
    }, []);

    const handleUpdateZoneTitle = useCallback(
      (newTitle) => {
        updateZoneTitle({ newTitle, zoneId });
      },
      [updateZoneTitle, zoneId],
    );

    const connectionCircleBg = isWirelessZone
      ? `url("${wifiIcon}") center / cover no-repeat, ${blue500}`
      : gray500;

    return (
      <div
        className={cx(
          "position-relative p-2 border border-gray-400 bg-gray-300 rounded-2 cursor-pointer",
          s.zoneTitle,
        )}
        style={{
          "--zoneTitleConnectionLine": isWirelessZone
            ? `dashed ${blue500}`
            : `solid ${gray400}`,
          "--zoneTitleConnectionCircleBg": connectionCircleBg,
          width: `${2 * nodeWidth + rightChildrenGapX - nodeHeight}px`,
        }}
      >
        <div className="position-relative d-flex">
          <TopologyEditableTitle
            title={title}
            zoneId={zoneId}
            maxLength={MAX_CUSTOM_PRODUCT_INPUT_LENGTH}
            handleUpdateTitle={handleUpdateZoneTitle}
            handleEditMode={handleEditMode}
            editMode={editMode}
            className="w-100"
            inputClassNames="w-100 justify-content-center px-2 fw-bold panzoomDisabled"
            style={{
              width: `${2 * nodeWidth + rightChildrenGapX}px`,
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div
                className="w-100 h5 mb-0 font18 font-bold text-gray-700 text-truncate cursor-pointer"
                id={`editZoneTitleIcon-${zoneId}`}
              >
                {title}
              </div>
              <Button
                data-testid="editIcon"
                square={true}
                color="tertiary"
                icon="pencil-light"
                iconClassName="icon-16"
                classNames="border-0 cursor-pointer"
              />
              <UncontrolledTooltip
                target={`editZoneTitleIcon-${zoneId}`}
                placement="top"
              >
                {title}
              </UncontrolledTooltip>
            </div>
          </TopologyEditableTitle>
        </div>
      </div>
    );
  },
);
